import React, { useState } from 'react';

import SEA from 'gun/sea';
import { useAccount } from 'wagmi';

import { instantiateGun } from '@/utils/instantiateGun';
import { sendNotifcation } from '@/utils/notification';
import { InputProps } from 'interfaces/ChatTab/chatTab';
import emojiIcon from 'public/assets/emojiIcon.svg';
import sendIcon from 'public/assets/sendIcon.svg';

const gun = instantiateGun();
const ChatInput = ({
  uuId,
  ipfsPreviewHash,
  createChat,
  setSignalNewMessage,
  setUserMessages,
}: InputProps) => {
  const [text, setText] = useState('');
  const { data: signer } = useAccount();
  const handleInputChange = (e: any) => {
    setText(e.target.value);
  };
  const sendComment = async () => {
    let previousMessages: any[] = [];
    try {
      setUserMessages((prev: any) => {
        previousMessages = prev;
        return [
          ...prev,
          {
            by: signer.address.toString().toLowerCase(),
            text,
          },
        ];
      });
      setText('');
      const response = await createChat({ uuId, text });

      if (response.status === 200) {
        setSignalNewMessage(false);
      } else {
        setUserMessages([...previousMessages]);
      }
    } catch (error) {
      sendNotifcation('Unable to send message', '', 'danger');
      setUserMessages([...previousMessages]);
    }
  };
  const saveMessage = async () => {
    const chatCollection: any = gun.get(`#${ipfsPreviewHash}`);
    const serializedChatData = JSON.stringify({
      by: signer?.address.toLowerCase(),
      text,
      createdAt: Date.now(),
    });
    const chatDataHash = await SEA.work(serializedChatData, null, null, {
      name: 'SHA-256',
    });

    chatCollection.get(chatDataHash).put(serializedChatData);
    setText('');
  };
  const handleKeyEvent = (event: any) => {
    if (event.key === 'Enter' && text && ipfsPreviewHash) {
      saveMessage();
    } else if (event.key === 'Enter' && text) {
      sendComment();
    }
  };

  return (
    <div
      className="flex border p-2 rounded-md border-black"
      onKeyDown={handleKeyEvent}
    >
      <div className="flex justify-center items-center p-2">
        <img src={emojiIcon.src} alt="emoji" className=" w-6" />
      </div>
      <input
        ref={(input) => input && input.focus()}
        onChange={handleInputChange}
        value={text}
        type="text"
        placeholder="Start typing"
        className=" p-2 w-full "
      />
      <button
        onClick={() => {
          if (ipfsPreviewHash) saveMessage();
          else sendComment();
        }}
        className="p-2 flex justify-center items-center"
      >
        <img src={sendIcon.src} alt="send" className=" w-6" />
      </button>
    </div>
  );
};

export default ChatInput;
